import React, { useEffect, useState } from 'react';
import './home.css';

import logoH from '../../../images/logo.png';

import Alert from '@material-ui/lab/Alert';
import { text } from '../../../utils/Multilanguage';
import { useSelector, useDispatch } from 'react-redux';
import { resetState } from '../../../redux/actions/directInspection/directInspectionAction';
import { resetStateArrivalDepature } from '../../../redux/actions/refreshArrivalDepature/refreshArrivalDepatureAction';
import DB from "../../../db";
import moment from "moment";

export default function Home({ language }) {
    const [direct_inspections, setDirect_Inspections] = useState(null);
    const [arrival_depature, setArrival_Depature] = useState(null);
    const refresh = useSelector((state) => state.directInspection);
    const refreshArrival = useSelector((state) => state.refreshArrivalDepature);

    const dispatch = useDispatch();

    useEffect(() => {
        const direct = localStorage.getItem('direct_inspections');
        const arrival_depature = localStorage.getItem('arrival_depature');

        if (direct !== null & direct !== undefined & direct !== "") {
            setDirect_Inspections(JSON.parse(direct)?.direct_inspections);
        }

        if (arrival_depature !== null & arrival_depature !== undefined & arrival_depature !== "") {
            setArrival_Depature(JSON.parse(arrival_depature));
        }
    }, []);

    const db = new DB();

    const arrivalDepatureMessage = async () => {
        const data = await db.getAll();

        if (data.length === 0) {
            localStorage.setItem('arrival_depature', '');
            setArrival_Depature(null);
        }

        for (var i = 0; i < data.length; i++) {
            const arrival = data[i].doc.arrival;
            const departure = data[i].doc.departure;

            if (arrival !== '' && departure !== '') {
                const result = { arrival, departure };
                setArrival_Depature(result);
                localStorage.setItem('arrival_depature', JSON.stringify(result));
                break;
            } else {
                localStorage.setItem('arrival_depature', '');
                setArrival_Depature(null);
            }
        }
    };

    useEffect(() => {
        if (refresh.refresh) {
            const direct = localStorage.getItem('direct_inspections');
            if (direct !== null & direct !== undefined & direct !== "") {
                setDirect_Inspections(JSON.parse(direct)?.direct_inspections);
                dispatch(resetState());
            }
        }

        if (refreshArrival.refreshArrivalDepature) {
            arrivalDepatureMessage();
            dispatch(resetStateArrivalDepature());
        }
    }, [refresh.refresh, refreshArrival.refreshArrivalDepature]);

    return (
        <div className="home_contenedor">
            {direct_inspections !== null && direct_inspections !== undefined && (
                <div className="contenedor_notificacion">
                    {direct_inspections.map((truck, index) => {
                        if (truck.status === "out") {
                            const mensaje = `${truck.type === "truck" ? text("Truck") : "Trailer"} # ${truck.number} ${text("is Out Of Service")}`;
                            return (
                                <Alert
                                    key={index}
                                    className="home_alert"
                                    variant="filled"
                                    severity="error"
                                    style={{ fontSize: "var(--font-size-sm)" }}
                                >
                                    {mensaje}
                                </Alert>
                            );
                        }
                        return null;
                    })}
                </div>
            )}

            {arrival_depature && (
                <div className="contenedor_notificacion">
                    <Alert
                        className="home_alert"
                        variant="filled"
                        severity="warning"
                        style={{ fontSize: "var(--font-size-sm)" }}
                    >
                        {language === "en" ? (
                            <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                                <div style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
                                    <strong>Came Out:</strong>
                                    <span>{moment(arrival_depature.departure).format("MM/DD/YYYY hh:mm A")}</span>
                                </div>
                                <div style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
                                    <strong>Authorized Entry:</strong>
                                    <span>{moment(arrival_depature.arrival).format("MM/DD/YYYY hh:mm A")}</span>
                                </div>
                            </div>
                        ) : (
                            <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                                <div style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
                                    <strong>Salio:</strong>
                                    <span>{moment(arrival_depature.departure).format("MM/DD/YYYY hh:mm A")}</span>
                                </div>
                                <div style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
                                    <strong>Entrada Autorizada:</strong>
                                    <span>{moment(arrival_depature.arrival).format("MM/DD/YYYY hh:mm A")}</span>
                                </div>
                            </div>
                        )}
                    </Alert>
                </div>
            )}

            <div className="home_img_contenedor">
                <img src={logoH} className="home_logo" alt="" />
                <p className="home_welcome">
                    {language === "en"
                        ? `Welcome, ${localStorage.getItem("name") || "Driver"}`
                        : `Bienvenido, ${localStorage.getItem("name") || "Conductor"}`
                    }
                </p>
            </div>
        </div>
    );
}
